import { BooleanValue } from '@/components/ui/BooleanValue/BooleanValue';
import { LabeledCheckbox } from '@/components/ui/LabeledCheckbox/LabeledCheckbox';
import { ControllerRenderProps } from 'react-hook-form';
import { ProcessedField } from './types';

interface BooleanFieldProps {
  field: ProcessedField;
  formMode: 'loading' | 'view' | 'edit';
  controllerField: ControllerRenderProps;
}

export function BooleanField({
  field,
  formMode,
  controllerField,
}: BooleanFieldProps) {
  const isDisabled = formMode === 'loading' || formMode === 'view';

  // Handle the value - ensure it's always a boolean
  const checked = !!controllerField.value;

  if (formMode === 'view') {
    // Read-only: neutral filled/hollow indicator + word. The field label is
    // already shown by the surrounding layout, so we don't repeat it here (that
    // duplication made the label read like the value).
    return <BooleanValue value={checked} />;
  }

  return (
    <div className="flex items-center space-x-2">
      <LabeledCheckbox
        variant={'bordered'}
        label={field.meta.label}
        checked={checked}
        name={controllerField.name}
        onCheckedChange={(value) => {
          controllerField.onChange(!!value);
        }}
        disabled={isDisabled}
        onBlur={controllerField.onBlur}
      />
    </div>
  );
}
